import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from 'LiveBoard/components/shared/Avatar'

import './style.css.scss'

const PersonalDetails = ({ seller, textColor }) => {
  return (
    <section className="seller-personal-details" >
      <Avatar url={seller.photo} color={textColor} />
      <div className='details'>
        <h1 className='name'>{(`${seller.name} ${seller.last_name}`).trim()}</h1>
        <h2 className='title' title={seller.headline}>{seller.headline}</h2>
        <h2 className='company'>{seller.company}</h2>
      </div>
    </section>
  )
}

PersonalDetails.propTypes = {
  seller: PropTypes.object.isRequired,
  textColor: PropTypes.string
}

export default PersonalDetails

